.banner-promo-block {
  height: 270px;
  margin: 0;
  padding: 0;
  border: 0;
  font: inherit;
  color: #ffffff;
  position: relative;
  margin-bottom: 20px;
}

.banner-promo-block :hover {
  background-color: rgba(51, 51, 51, 0.4);
}

.banner-promo-block :hover h4 {
  transform: translateY(-15px);
  transition: transform 0.15s;
}

.banner-promo-block__context-link {
  text-decoration: none;
}

.banner-promo-block__context-link_underline {
  text-decoration: underline;
}

@media screen and (max-width: 979px) {
  .banner-promo-block {
    height: 160px;
  }
}

.banner-promo-block__image-wrap {
  height: 270px;
  position: relative;
}

@media screen and (max-width: 979px) {
  .banner-promo-block__image-wrap {
    height: 160px;
  }
}

.banner-promo-block__image-wrap ::after {
  position: absolute;
  content: "";
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: linear-gradient(0deg, rgba(51, 51, 51, 0.95), rgba(51, 51, 51, 0.4));
}

.banner-promo-block__wrapper {
  position: relative;
  margin: 0;
  padding: 0;
  border: 0;
  font: inherit;
  vertical-align: baseline;
}

.banner-promo-block__picture {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

@media screen and (max-width: 979px) {
  .banner-promo-block__picture {
    height: 160px;
  }
}

.banner-promo-block__picture source {
  width: 100%;
  height: 100%;
}

.banner-promo-block__picture img {
  min-width: 100%;
  min-height: 100%;
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
  position: absolute;
}

:host(:not([dir="rtl"])) .banner-promo-block__picture img {
  right: 0;
}

:host([dir="rtl"]) .banner-promo-block__picture img {
  left: 0;
}

.banner-promo-block__context {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  padding: 20px 20px 5px;
  color: #fff;
}

.banner-promo-block__context :hover {
  background-color: rgba(51, 51, 51, 0);
}

.banner-promo-block__context-description {
  margin: 0;
  margin-bottom: 10px;
  font-size: 1rem;
  line-height: 25px;
  max-width: 506px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.banner-promo-block__context h4 {
  margin: 0;
  font-size: 1.375rem;
  line-height: 2.5rem;
  margin-bottom: 15px;
  max-width: 100%;
  transition: transform 0.15s;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

@media screen and (max-width: 979px) {
  .banner-promo-block__context h4 {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}

.banner-promo-block__context-panel {
  display: flex;
  width: auto;
  justify-content: flex-start;
  font-size: 0.8125rem;
  cursor: pointer;
}

.banner-promo-block__context-panel-link {
  display: flex;
  align-items: center;
}

:host(:not([dir="rtl"])) .banner-promo-block__context-panel-link {
  margin-right: 6px;
}

:host([dir="rtl"]) .banner-promo-block__context-panel-link {
  margin-left: 6px;
}

.banner-promo-block__context-link {
  font-size: 0.8125rem;
  line-height: 25px;
  color: #fff;
  text-decoration: none;
}

.banner-promo-block__context-link_underline {
  text-decoration: underline;
}

.banner-promo-block__context-link:visited, .banner-promo-block__context-link:active {
  text-decoration: none;
}

.banner-promo-block__context-link-icon {
  position: relative;
}

:host(:not([dir="rtl"])) .banner-promo-block__context-link-icon {
  left: 2px;
}

:host([dir="rtl"]) .banner-promo-block__context-link-icon {
  right: 2px;transform:scaleX(-1);
}

.banner-promo-block__context-button-block {
  display: flex;
  align-items: center;
}

.banner-promo-block__context-button {
  margin: 0;
  padding: 0;
  border: none;
  color: #fff;
  background: transparent;
  z-index: 10;
  cursor: pointer;
}

.banner-promo-block__context-button:hover {
  text-decoration: underline;
}

.banner-promo-block__context-icon-play {
  height: 15px;
  width: 15px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 40 40' id='play-hover-40x40'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Ccircle stroke='%23fff' stroke-width='2' cx='20' cy='20' r='19'%3E%3C/circle%3E%3Cpath d='M18.453 14.25l6.467 5.022a1 1 0 010 1.58l-6.467 5.022a1 1 0 01-1.613-.79V15.04a1 1 0 011.613-.79z' fill='%23fff'%3E%3C/path%3E%3C/g%3E%3C/svg%3E");
}

:host(:not([dir="rtl"])) .banner-promo-block__context-icon-play {
  margin-left: 5px;
}

:host([dir="rtl"]) .banner-promo-block__context-icon-play {
  margin-right: 5px;
}

.banner-promo-block__modal-window {
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 60;
  background: rgba(51, 51, 51, 0.6);
}

.banner-promo-block__modal-window-content {
  max-width: 1140px;
}